function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import classnames from 'classnames';
import { Button } from "../../Button/Button/Button";
import { Container } from "../../Container/Container/Container";
import { FlagCountryNameBlock } from "../../Block/FlagCountryNameBlock/FlagCountryNameBlock";
import { Image } from "../../Image/Image/Image";
import { Link } from "../../Button/Link/Link";
import { Text } from "../../Text/Text/Text";
import Utility from "../../Utility/Utility";
import styles from "./FooterLegalSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FooterLegalSlice = function FooterLegalSlice(_ref) {
  var _ref$copyright = _ref.copyright,
    copyright = _ref$copyright === void 0 ? '' : _ref$copyright,
    country = _ref.country,
    _ref$hasTruste = _ref.hasTruste,
    hasTruste = _ref$hasTruste === void 0 ? false : _ref$hasTruste,
    legal = _ref.legal,
    _ref$legitScript = _ref.legitScript,
    legitScript = _ref$legitScript === void 0 ? false : _ref$legitScript;
  var renderLegalLinks = function renderLegalLinks() {
    return /*#__PURE__*/_jsx("ul", {
      className: styles.footerLegalLinksList,
      "data-e2e-name": "footer_legal_links",
      children: legal && legal.map(function (item, i) {
        return /*#__PURE__*/_jsx("li", {
          className: styles.footerLegalLinksListItem,
          "data-e2e-name": "footer_legal_list_item",
          children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
            accessibilityLabel: Utility.getLinkTitleText(item.text, item.title),
            newWindow: item.newWindow,
            type: "no-style",
            url: item.url
          }, item.attributes), {}, {
            children: /*#__PURE__*/_jsx(Text, {
              textElement: "span",
              typog: "bodycopySmall",
              className: styles.legalLink,
              children: item.text
            })
          }))
        }, i);
      })
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    "aria-label": "Footer Legal",
    className: classnames('webview', styles.footerLegal),
    "data-e2e-name": "footer_legal",
    id: "footer-legal",
    role: "contentinfo",
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs("div", {
        "data-e2e-name": "footer_legal_links",
        className: styles.footerLegalLinks,
        children: [renderLegalLinks(), /*#__PURE__*/_jsx("div", {
          className: styles.footerLegalCountry,
          children: /*#__PURE__*/_jsx(FlagCountryNameBlock, _objectSpread({}, country))
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.footerLegalCopyrightContainer,
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs("div", {
          className: classnames(styles.footerLegalCopyright, legitScript && styles.footerLegalCopyrightLegitScript),
          children: [hasTruste && /*#__PURE__*/_jsx("div", {
            className: styles.footerLegalTruste,
            "data-e2e-name": "footer_truste",
            children: /*#__PURE__*/_jsx(Link, {
              accessibilityLabel: "TRUSTe Privacy Certification",
              newWindow: true,
              rel: "noopener noreferrer",
              url: "//privacy.truste.com/privacy-seal/validation?rid=4d012e1f-79b3-47d6-ae3f-f53fb76d2de0",
              children: /*#__PURE__*/_jsx(Image, {
                alt: "TRUSTe Privacy Certification",
                className: styles.footerLegalTrusteImage,
                height: "45",
                src: "//privacy-policy.truste.com/privacy-seal/seal?rid=4d012e1f-79b3-47d6-ae3f-f53fb76d2de0",
                width: "142"
              })
            })
          }), legitScript && /*#__PURE__*/_jsx("div", {
            className: styles.footerLegalLegitScript,
            "data-e2e-name": "footer_legitscript",
            children: /*#__PURE__*/_jsx(Link, {
              accessibilityLabel: "Verify LegitScript Approval",
              newWindow: true,
              rel: "noopener noreferrer",
              url: "//legitscript.com/",
              children: /*#__PURE__*/_jsx(Image, {
                alt: "LegitScript approved",
                src: "//static.legitscript.com/seals/8215583.png"
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Text, {
              className: styles.footerLegalCopyrightText,
              "data-e2e-name": "footer_legal_copyright",
              richText: true,
              typog: "captionSmall",
              children: copyright
            })
          })]
        })
      })
    })]
  });
};